const getDefaultState = () => {
	return {

	}
}

const default_state = getDefaultState()

export { default_state }